import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../components/hooks/useFetch";
import { IoMdArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function CategoryDetails() {
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const { loading, error, data } = useFetch(`${process.env.REACT_APP_API_URL}/categories/${id}`, token);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;

  const title = data?.title || "No title available";
  const description = data?.description || "No description available";
  const createdAt = data?.created_at || "Date not available";

  return (
    <>
      <Navbar />
      <div className='w-full text-black bg-gray-100 shadow'>
        <div className="justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8'">
          <Link to="/category" className="text-blue-600 hover:text-blue-800 flex items-center">
            <IoMdArrowBack className="mr-1" /> Back to Categories
          </Link>
        </div>
        <div className='justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8'>
        
          <table className='w-full table-auto min-w-max'>
            <thead>
              <tr className='text-sm leading-normal text-gray-100 capitalize bg-gray-600'>
                <th className='px-6 py-3 text-left'>Title</th>
                <th className='px-6 py-3 text-left'>Description</th>
                <th className='px-6 py-3 text-center'>Published Date</th>
              </tr>
            </thead>
            <tbody>
              <tr className='text-sm leading-normal text-gray-600 bg-gray-200'>
                <td className='px-6 py-3 text-left'>{title}</td>
                <td className='px-6 py-3 text-left'>{description}</td>
                <td className='px-6 py-3 text-center'>{createdAt}</td>
              </tr>
            </tbody>
          </table>
        </div>
       
      </div>
      <Footer />
    </>
  );
}
